import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=7a651eb0&"
import script from "./Fees.vue?vue&type=script&lang=js&"
export * from "./Fees.vue?vue&type=script&lang=js&"
import style0 from "./Fees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports